import _ from "lodash";
import XLSX from "xlsx";

export default (file, lang) => {

 function convertSpecialChars(text) {
  if (typeof text !== 'string') {
    return text; // Eğer text bir string değilse, olduğu gibi geri döner
  }
  // Türkçe karakterler ve sayılar hariç tüm karakterleri değiştirme
  return text.replace(/[^a-zA-Z0-9ğüşıöçĞÜŞİÖÇ@.,_\- ()[\]{}!?:;]/g, '');// Boşluk karakterini de korumak için boşluğu ekledik
};


  const workbook =
    typeof window === "undefined"
      ? XLSX.readFile(file)
      : XLSX.read(file, { type: "binary" });
  const sheetNames = workbook.SheetNames;
  if (sheetNames.length === 0) {
    return Promise.reject({ error: lang.error.noWorksheet });
  }
  const sheets = workbook.Sheets;
  const json = XLSX.utils.sheet_to_json(sheets[sheetNames[0]], {
    header: 1,
    defVal: "",
    blankrows: false
  });

  if (json.length === 0) {
    return Promise.reject({ error: lang.error.emptyWorksheet });
  }

  // 50,000 kayıt sınırı kontrolü (başlık satırı hariç)
  const recordCount = json.length - 1; // Başlık satırını sayma
  if (recordCount > 50000) {
    return Promise.reject({ 
      error: `Dosyada ${recordCount.toLocaleString('tr-TR')} kayıt bulundu. Maksimum 50.000 kayıt yükleyebilirsiniz.` 
    });
  }

  const transposedMatrix = _.unzip(json);
  const normalizedOutput = transposedMatrix
    .map(columnRows => ({
      name: _.first(columnRows),
      data: _.tail(columnRows).map(item => convertSpecialChars(item)) // data kısmındaki her item'a uygular
    
    }))
    .filter(
      column =>
        column.data.length === 0 ||
        !column.data.every(data => data === undefined)
    );

  return Promise.resolve({ worksheet: normalizedOutput });
};
